// extracted by mini-css-extract-plugin
module.exports = {"imagecard":"AboutUsPage_imagecard__2GQeP","visiontext":"AboutUsPage_visiontext__24ujn","secondcard":"AboutUsPage_secondcard__2X7Zw","imagecards":"AboutUsPage_imagecards__1VuOS"};